export const iconFontAwesomeHumanitarianUsersLine = (
	<i className="fa-solid fa-users-line"></i>
);
